import React, {useLayoutEffect, useState} from "react";
import {HeaderType, useHeaderView} from "store/header/header.store";
import FlexBox from "view/components/Layout/FlexBox";
import {FFairPrimaryIconBlueLogo} from "view/images/FFairLogo";
import Button from "@material-ui/core/Button";
import {BrandingType} from "@evennt-tech/api-v2-core";
import useBranding from "store/branding/branding.store";
import {SHOW_BAR_HEIGHT} from "view/components/AppBar/components/ShowBar/styles";
import {useMaintenanceModeStore} from "store/general/maintenanceMode.store";
import {useCurrentShowId} from "hooks";
import {Link} from "react-router-dom";
import useStyles from "./styles";

function QuickOrderHeader() {
  const showId = useCurrentShowId();
  const [headerHeight, setHeaderHeight] = useState(SHOW_BAR_HEIGHT);
  const {panelHeight} = useMaintenanceModeStore();

  const classes = useStyles();
  const {brandings} = useBranding();
  const branding = brandings[showId];
  const {headerView} = useHeaderView();

  useLayoutEffect(() => {
    setHeaderHeight(panelHeight + SHOW_BAR_HEIGHT);
  });

  if (headerView.type !== HeaderType.QUICK_ORDER) {
    return null;
  }

  let headerBackground: string | undefined;
  const transformedOpacity = !branding?.bannerOpacity
    ? 0
    : 1 - branding.bannerOpacity / 100;
  const opacity = `linear-gradient(rgba(0,0,0,${transformedOpacity}), rgba(0,0,0,${transformedOpacity}))`;
  const gradientOverlay =
    "linear-gradient(270deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 77.38%), linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 74.34%)";
  headerBackground =
    branding?.bannerType === BrandingType.COLOR
      ? branding?.bannerColor?.hex || undefined
      : `${opacity}, url("${branding?.bannerImage?.url}")`;
  headerBackground =
    branding?.hideBannerOverlay || branding?.bannerType === BrandingType.COLOR
      ? headerBackground
      : `${gradientOverlay}, ${headerBackground}`;

  return (
    <FlexBox
      column
      gap={3.5}
      className={classes.root}
      style={{
        height: headerHeight,
        backgroundImage:
          branding?.bannerType === BrandingType.IMAGE
            ? headerBackground
            : undefined,
        backgroundColor:
          branding?.bannerType === BrandingType.COLOR
            ? headerBackground
            : undefined,
      }}
    >
      <FlexBox alignCenter gap={1.5}>
        <FFairPrimaryIconBlueLogo />
        <span className={classes.logoName}>FFAIR</span>
      </FlexBox>
      <FlexBox alignCenter justifyBetween>
        <span className={classes.orderId}>Order #{headerView.orderId}</span>
        <Link to="/" target="_blank">
          <Button color="primary">Back to Ffair Portal</Button>
        </Link>
      </FlexBox>
    </FlexBox>
  );
}

export default QuickOrderHeader;
